/// <amd-module name="Wit/Common/WitSettingsViews/Components/StylesTable/StyleCriteriaConstants" />
import { CoreFieldRefNames, FieldType } from "Wit/Common/Generated/Constants";
import { getLocalizedOperatorList, HistoryOperators, TextOperators, TextWithTextSupportOperators, WiqlOperators } from "Wit/Common/WiqlOperators";

export namespace StyleCriteriaConstants {
    export const stringOperators: string[] = getLocalizedOperatorList([
        WiqlOperators.OperatorEqualTo,
        WiqlOperators.OperatorNotEqualTo,
        WiqlOperators.OperatorContains,
        WiqlOperators.OperatorNotContains
    ]);

    export const equalityOperators: string[] = getLocalizedOperatorList([WiqlOperators.OperatorEqualTo, WiqlOperators.OperatorNotEqualTo]);

    export const comparisonOperators: string[] = getLocalizedOperatorList([
        WiqlOperators.OperatorEqualTo,
        WiqlOperators.OperatorNotEqualTo,
        WiqlOperators.OperatorGreaterThan,
        WiqlOperators.OperatorLessThan,
        WiqlOperators.OperatorGreaterThanOrEqualTo,
        WiqlOperators.OperatorLessThanOrEqualTo
    ]);

    export const treePathOperators: string[] = getLocalizedOperatorList([
        WiqlOperators.OperatorEqualTo,
        WiqlOperators.OperatorNotEqualTo,
        WiqlOperators.OperatorUnder,
        WiqlOperators.OperatorNotUnder
    ]);

    export const textWithTextSupportOperators: string[] = getLocalizedOperatorList(TextWithTextSupportOperators);
    export const textOperators: string[] = getLocalizedOperatorList(TextOperators);
    export const historyOperators: string[] = getLocalizedOperatorList(HistoryOperators);
    export const maxCriteria = 5;

    export const supportedFieldTypes = new Set([
        FieldType.String,
        FieldType.Integer,
        FieldType.PlainText,
        FieldType.Double,
        FieldType.TreePath,
        FieldType.DateTime,
        FieldType.Boolean
    ]);

    export const notSupportedFieldReferenceNames = new Set([
        CoreFieldRefNames.Id.toLowerCase(),
        CoreFieldRefNames.AreaId.toLowerCase(),
        CoreFieldRefNames.IterationId.toLowerCase(),
        CoreFieldRefNames.Rev.toLowerCase(),
        CoreFieldRefNames.RevisedDate.toLowerCase(),
        CoreFieldRefNames.TeamProject.toLowerCase(),
        CoreFieldRefNames.Watermark.toLowerCase(),
        CoreFieldRefNames.ExternalLinkCount.toLowerCase(),
        CoreFieldRefNames.HyperLinkCount.toLowerCase(),
        CoreFieldRefNames.RelatedLinkCount.toLowerCase(),
        CoreFieldRefNames.AttachedFileCount.toLowerCase(),
        CoreFieldRefNames.AuthorizedAs.toLowerCase(),
        CoreFieldRefNames.AuthorizedDate.toLowerCase(),
        CoreFieldRefNames.LinkType.toLowerCase()
    ]);
}
